import React from "react";

function Sidebar() {
  return <div className="sidebar"></div>;
}

export default Sidebar;
